import Moment from 'moment';
import { Box, Text, Tooltip } from '@cowbell/ui';
import { useQueryParams } from '../../../../../components/providers/QueryParamsProvider';
import { Highlighter } from '../../CmailListing';
import type {
  MessageInfo,
  MessageInfoChild,
} from '../../../../../api/cmail/cmail.dto';
import classes from './Title.module.css';

/** `Sep 27, 2026 10:26 PM` and `6 days ago`; the full date is on hover. */
export const receivedLabel = (dateReceived: string | number | undefined) => {
  const received = Moment(dateReceived);
  return { absolute: received.format('lll'), relative: received.fromNow() };
};

/** The header's first row: the subject, and when the message arrived. */
export const Title = ({
  message,
}: Readonly<{
  message: MessageInfo | MessageInfoChild;
}>) => {
  const { query } = useQueryParams();
  const received = receivedLabel(message.dateReceived);

  return (
    <Box className={classes.wrapper}>
      <Text className={classes.subjectText}>
        <Highlighter search={query.search}>{message.subject}</Highlighter>
      </Text>
      <Tooltip label={Moment(message.dateReceived).format('LLLL')}>
        <Text className={classes.received}>
          {received.absolute}
          <span className={classes.relative}>{received.relative}</span>
        </Text>
      </Tooltip>
    </Box>
  );
};
